var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.23 58.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6,41.65A2.72,2.72,0,0,0,34.18,41c-.78.73-1.51,1.5-2.26,2.25-2.85,2.84-5.66,5.71-8.54,8.52a6.65,6.65,0,0,1-7,1.62c-5-1.57-6.36-8.13-2.66-11.86,4.14-4.19,8.32-8.34,12.49-12.51,2.82-2.83,5.63-5.67,8.48-8.47a2.88,2.88,0,0,0,.81-3.11A2.69,2.69,0,0,0,31,16.37c-1.09,1-2.12,2.07-3.16,3.13s-2.09,2.09-3.13,3.14a8.91,8.91,0,0,1-3.92,2.27,10.2,10.2,0,0,0-3.12,1.39,21,21,0,0,0-2.4,2.22A13.75,13.75,0,0,0,13,33a9,9,0,0,1-2.15,3.54q-.72.72-1.41,1.44A12.2,12.2,0,0,0,6.43,49.88c1.24,5.21,6.33,9.44,11.14,9.33,3.93,0,6.61-.87,8.86-2.79,1.54-1.32,2.94-2.81,4.38-4.24L38,45A2.8,2.8,0,0,0,38.6,41.65Z",
    transform: "translate(-6 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.52,27.21a4.25,4.25,0,1,0-6-.08A4.25,4.25,0,0,0,15.52,27.21Z",
    transform: "translate(-6 -1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.63,18.56a2.72,2.72,0,0,0,4.42.67c.78-.73,1.51-1.5,2.26-2.25,2.85-2.84,5.66-5.71,8.54-8.51a6.64,6.64,0,0,1,7-1.63c5,1.57,6.36,8.13,2.66,11.86C39.34,22.89,35.16,27,31,31.21c-2.82,2.83-5.63,5.67-8.48,8.47a2.88,2.88,0,0,0-.81,3.11,2.7,2.7,0,0,0,4.49,1.06c1.09-1,2.12-2.08,3.16-3.14s2.09-2.09,3.13-3.14A8.91,8.91,0,0,1,36.4,35.3a10.2,10.2,0,0,0,3.12-1.39,21,21,0,0,0,2.4-2.22,13.75,13.75,0,0,0,2.27-4.46,9,9,0,0,1,2.15-3.54q.72-.72,1.41-1.44a12.2,12.2,0,0,0,3-11.92C49.56,5.12,44.47.89,39.66,1c-3.93,0-6.61.87-8.86,2.79C29.26,5.11,27.86,6.6,26.42,8L19.2,15.25A2.8,2.8,0,0,0,18.63,18.56Z",
    transform: "translate(-6 -1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.71,33a4.25,4.25,0,1,0,6,.08A4.25,4.25,0,0,0,41.71,33Z",
    transform: "translate(-6 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.2e1eaaa5.svg";
export { ForwardRef as ReactComponent };